import {Selectors} from "@core/store/selectors";
import {
  Avatar,
  Stack,
  SxProps,
  Theme,
  Typography,
  TypographyVariant,
} from "@mui/material";
import {findAsset, renderAssetTypeIcon, translate, truncateSx} from "@util";
import {useSelector} from "react-redux";

const Asset = ({
  id,
  variant,
  size,
  emptyLabel,
  sx,
  subtitleVariant,
}: {
  id: string | undefined | null;
  variant?: TypographyVariant;
  size?: "inherit" | "large" | "medium" | "small";
  emptyLabel?: string;
  sx?: SxProps<Theme>;
  subtitleVariant?: TypographyVariant;
}) => {
  const assets = useSelector(Selectors.assets);
  const asset = id && assets ? findAsset(assets, id) : undefined;

  const width =
    size === "large"
      ? 40
      : size === "medium"
        ? 32
        : size === "small"
          ? 24
          : "inherit";

  return (
    <Stack
      direction={"row"}
      gap={1}
      alignItems={"center"}
      sx={{minWidth: 0, inlineSize: "100%", ...sx}}>
      <Avatar
        sx={{
          width,
          height: width,
          "& .MuiSvgIcon-root": {width: "0.8em", height: "0.8em"},
        }}>
        {renderAssetTypeIcon(asset?.type)}
      </Avatar>
      <Stack>
        <Typography
          variant={variant ?? "body1"}
          textAlign="center"
          color="textPrimary"
          textTransform={"capitalize"}
          sx={{...truncateSx}}>
          {asset ? asset.name : (emptyLabel ?? "-")}
        </Typography>
        {subtitleVariant && (
          <Typography
            lineHeight={1.1}
            variant={subtitleVariant}
            color="text.secondary"
            textAlign={"start"}>
            {translate("entity.artifact.asset")}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export {Asset};
